import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../../store/actions/notificationAction';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from '../../../models/ApiResponse';
import ResponseError from '../../../models/ResponseError';
import GhaPickupStatusAwb from '../../../models/GhaPickupStatusAwb';
import GhaPickupStatus from '../../../models/GhaPickupStatus';

import InterlineCheck from './InterlineCheck';

import { Value } from '../../../models/OtherChecksForm';
import { InterlineChecksForm, InterlineChecks, InterlineCarrier } from '../../../models/InterlineChecks';

interface InterlineContainerProps {
  poAwb: GhaPickupStatusAwb;
  doNumber: string;
  code: string;
  number: string;
  awbVer: number;
  receiveError: Function;
  onlyRead?: boolean;
  checkElement: (check: boolean) => JSX.Element;
  deliveredDate: string;
  setStatusIterline: (statusInterline: boolean) => void;
};

interface InterlineCheckContainerState {
  doNumber: string;
  awbCode: string;
  interlineChecks: InterlineChecks;
  awbNumber: string;
  awbVer: number;
  deliveredDate: string;
  interline_transfer_program: InterlineCarrier;
  ver: number;
  carrierList: Array<any>;
  securityNote: string;
};

interface Data {
  interline_form_ver: number,
  interline_form_data: Array<Value>,
  carrier: InterlineCarrier
};

class ReadyForCarriageCheckContainer extends Component<InterlineContainerProps, InterlineCheckContainerState> {

  state = {
    interlineChecks: {
      interline_form_data: {
        interline_form_ver: -1,
        interline_form_data: [],
        interline_form_green: [],
      },
      interline_form_green: false,
      interline_form_ver: -1,
      interline_form: []
    },
    ver: -1,
    awbVer: -1,
    doNumber: '',
    awbCode: '',
    awbNumber: '',
    interline_transfer_program: { carrier: '', transfer_programs: ['', '', '', ''] },
    deliveredDate: '',
    carrierList: [],
    securityNote: ''
  };

  componentDidMount() {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.code;
    const awbNumber: string = this.props.number;
    const awbVer: number = this.props.awbVer;
    this.getCarrierList();

    if (this.props.doNumber && this.props.code && this.props.number) {
      const interline_transfer_program: any = { ...this.state.interline_transfer_program };
      const securityNote: string = this.props.poAwb.security_notes ? this.props.poAwb.security_notes : '';
      if(interline_transfer_program && interline_transfer_program.carrier) {
        interline_transfer_program.carrier = { label: this.props.poAwb.interline_transfer_program.carrier, value: this.props.poAwb.interline_transfer_program.carrier }
        interline_transfer_program.transfer_programs = this.props.poAwb.interline_transfer_program.transfer_programs;   
      }
      this.setState({ doNumber, awbCode, awbNumber, interline_transfer_program, securityNote, awbVer });
      this.loadOrPostData('load', doNumber, awbCode, awbNumber, awbVer);
    }
  }

  componentDidUpdate(prevProps: InterlineContainerProps) {

    const doNumber: string = this.props.doNumber;
    const awbCode: string = this.props.code;
    const awbNumber: string = this.props.number;

    if (prevProps.doNumber !== doNumber && prevProps.number !== awbNumber) {

      this.setState({ doNumber, awbCode, awbNumber });

    }
  }

  handleChange = (event: any): void => {

    const value: Value = event.target.value;
    const id: number = +event.target.id

    const formData: any = [...this.state.interlineChecks.interline_form_data.interline_form_data]
    formData[id] = value;

    const interlineChecks: InterlineChecks = { ...this.state.interlineChecks }

    interlineChecks.interline_form_data.interline_form_data = formData;

    this.setState({ interlineChecks });

    this.loadOrPostData('post', this.state.doNumber, this.state.awbCode, this.state.awbNumber, this.state.awbVer, formData);

  };

  handleChangeNumber = (event: any): void => {

    const name: string = event.target.id;
    const value: string = event.target.value;

    switch (name) {
      case 'securityNote': this.setState({ securityNote: value }); break;
      default: break;
    }
  };

  getCarrierList = (): void => {
    pickupOrderRemote.getCarrierList().then((resp: ApiResponse<any>) => {
      const list: any | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (list) {

        this.setState({ carrierList: list })
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleSetNumber = (event: any): void => {

    const name: string = event.target.id;
    const poAwb: GhaPickupStatusAwb = { ... this.props.poAwb };

    switch (name) {
      case 'securityNote': poAwb.security_notes = this.state.securityNote; break;
      default: break;
    }

    this.handlePutPoAwbSecurityCheck(this.props.doNumber, this.props.code, this.props.number, this.props.awbVer, poAwb);

  };

  handlePutPoAwbSecurityCheck = (poNumber: string, awbCode: string, awbNumber: string, ver: number, poAwb: GhaPickupStatusAwb): void => {

    pickupOrderRemote.updateGhaPoAwbSecurityChecks(poNumber, awbCode, awbNumber, ver, poAwb).then((resp: ApiResponse<GhaPickupStatus>) => {
      const status: GhaPickupStatus | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  loadOrPostData = (type: string, doNumber: string, code: string, number: string, ver: number, form?: Array<Value>, val?: string): void => {

    let data: Data = {
      interline_form_ver: -1,
      interline_form_data: [],
      carrier: {} as InterlineCarrier
    };

    if (form) {
      data = {
        interline_form_ver: this.state.ver,
        interline_form_data: form,
        carrier: this.state.interline_transfer_program
      };
    }

    const result: Promise<ApiResponse<InterlineChecks>> =
      (type === 'load') ? pickupOrderRemote.getGhaPoAwbInterlineChecks(doNumber, code, number, ver) : pickupOrderRemote.updateGhaPoAwbInterlineChecks(doNumber, code, number, ver, data, val);

    result.then((resp: ApiResponse<InterlineChecks>) => {
    
      const result: InterlineChecks | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {

        const otherStatus: boolean = result.interline_form_green;
        // this.props.setStatusOther(otherStatus);
        let interlineChecks: any = { ...result };
        this.props.setStatusIterline(otherStatus);

        if (!interlineChecks.interline_form_data) {

          const length: number = interlineChecks.interline_form.length;
          const interline_form_ver: number = interlineChecks.interline_form_ver;
          const interline_form_data: Array<Value> = [];

          interlineChecks.interline_form.map((val: InterlineChecksForm) => {
            interline_form_data.push(val.default_value)
          }
          );
          const interline_form_green: Array<boolean> = Array(length).fill(false);
          interlineChecks.interline_form_data = {
            interline_form_ver,
            interline_form_data,
            interline_form_green,
          };
        }
        const interline_transfer_program: any = { ...this.state.interline_transfer_program };
        if(type === 'load') {
          interline_transfer_program.transfer_programs = this.props.poAwb.interline_transfer_program ? this.props.poAwb.interline_transfer_program.transfer_programs : []; 
          interline_transfer_program.carrier = this.props.poAwb.interline_transfer_program ?  { label: this.props.poAwb.interline_transfer_program.carrier, value: this.props.poAwb.interline_transfer_program.carrier } : {};
        }
        type !== 'load' ? interline_transfer_program.transfer_programs = interlineChecks.carrier.transfer_programs : null;
        this.setState({ interlineChecks, ver: interlineChecks.interline_form_ver, interline_transfer_program });
      }

      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  handleSetCarrier = (event: any): void => {

    const interline_transfer_program: any = { ...this.state.interline_transfer_program };
    interline_transfer_program.carrier = event;
    this.setState({ interline_transfer_program }, () => {
      this.loadOrPostData('post', this.state.doNumber, this.state.awbCode, this.state.awbNumber, this.state.awbVer, this.state.interlineChecks.interline_form_data.interline_form_data, 'carrier');
    });

  };

  render() {

    return (
      <InterlineCheck
        poAwb={ this.props.poAwb }
        deliveredDate={ this.props.deliveredDate }
        onlyRead={ this.props.onlyRead }
        awbCode={ this.props.code }
        interlineChecks={ this.state.interlineChecks }
        carrierNumber={ this.state.interline_transfer_program }
        handleSelectChange={ this.handleChange }
        handleSetCarrier={ this.handleSetCarrier }
        handleSetNumber={ this.handleSetNumber }
        checkElement={ this.props.checkElement }
        carrierList={ this.state.carrierList }
        handleChangeNumber={ this.handleChangeNumber }
        securityNote={ this.state.securityNote }
      />
    );
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error))
  };
}

export default connect(null, mapDispatchToProps)(ReadyForCarriageCheckContainer);